export default {
    // récuperer toutes les users dans la base de données 
    get_auth_users(tokens) {
        return axios.get('/authuser', {
            headers: {
                Authorization: "Bearer " + tokens
            }
        })
    },
    get_all_users(serverParams){
        return axios.post('/user/list?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_users_by_entity(serverParams){
        return axios.post('/users/entite/'+serverParams.entite_id+'?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_users_by_user(serverParams){
        return axios.post('/user/to/planning?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_users_own(serverParams){
        return axios.get('/mesutilisateurs?page=' + serverParams.page, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les users dans la base de données 
    post_users(user){
        return axios.post('/users',user, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // Mot de passe oublié 
    forget_password(user){
        return axios.post('/password/create',user, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_users(id,user){
        return axios.put('/users/'+id,user, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_users(id){
        return axios.get('/users/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_users(id){
        return axios.delete('/users/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    desactive_users(id){
        return axios.get('/desactive/user/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    active_users(id){
        return axios.get('/active/user/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}